import { z } from "zod";
import { UserSchema } from "./User";

export const ReceiverGroupFieldsSchema = z.object({
  id: z.number(),
  name: z.string(),
  isActive: z.boolean(),
  userType: z.number(),
  criteria: z.array(
    z.object({
      id: z.number(),
      userType: z.number(),
      featureType: z.number(),
      feature: z.string(),
      index: z.number(),
      comparison: z.number(),
      value: z.string(),
      valueType: z.number(),
    })
  ),
});

export const PartialReceiverGroupFieldsSchema =
  ReceiverGroupFieldsSchema.deepPartial();

export const ReceiverGroupExtraFieldsSchema = z.object({
  matchingUsers: z.array(UserSchema).optional(),
});

export const PartialReceiverGroupExtraFieldsSchema =
  ReceiverGroupExtraFieldsSchema.deepPartial();

export const ReceiverGroupSchema = z.intersection(
  ReceiverGroupFieldsSchema,
  ReceiverGroupExtraFieldsSchema
);

export type ReceiverGroup = z.infer<typeof ReceiverGroupSchema>;
export type ReceiverGroupPartial = z.infer<
  typeof PartialReceiverGroupFieldsSchema
>;
export type ReceiverGroupFields = z.infer<typeof ReceiverGroupFieldsSchema>;
export type PartialReceiverGroupFields = z.infer<
  typeof PartialReceiverGroupFieldsSchema
>;
export type ReceiverGroupExtraFields = z.infer<
  typeof ReceiverGroupExtraFieldsSchema
>;
export type PartialReceiverGroupExtraFields = z.infer<
  typeof PartialReceiverGroupExtraFieldsSchema
>;
